<template>
  <div class="bandwidth-comparison">
    <div class="progress-bar-wrapper" v-for="progressBar in progressBarItems" :key="progressBar.id">
      
      <div class="progress-bar" :class="{ emphasized: bandwidthSum >= progressBar.max }" :data-sum="bandwidthSum" :data-max="progressBar.max">
        <div class="step" 
            v-for="bandwidth in bandwidthItems"
            :key="bandwidth.title"
            :class="{ active: bandwidth.checked }"
            :style="{ width: getProgress(progressBar, bandwidth), backgroundColor: bandwidth.color }"
            :tooltip="bandwidth.title">
        </div>
      </div>
      <h3 class="title">{{ progressBar.title }}</h3>
    </div>

    <div class="py-2"></div>

    <div class="lg:w-3/4">
      <div class="bandwidth-category-wrapper">
        <label class="bandwidth-category" v-for="bandwidth in bandwidthItems" :key="bandwidth.title">
            <input type="checkbox" name="bandwidths[]" class="hidden" v-model="bandwidth.checked">
            <div class="inner" :class="{ active: bandwidth.checked }" :style="{ backgroundColor: bandwidth.color }">
                <div class="color-indicator" :style="{ backgroundColor: bandwidth.color }"></div>                
                <img :src="getImageUrl(bandwidth.icon, 200, 200)" alt="">
                <span class="title">{{ bandwidth.title }}</span>
            </div>
        </label>
      </div>
    </div>

  </div>
</template>

<script>

export default {
  name: 'bandwidth-comparison',
  props: {
    bandwidths: String,
    progressBars: String
  },
  data() {
    return {
      bandwidthItems: [],
      progressBarItems: []
    };
  },
  methods: {
    getProgress: function(progressBar, bandwidth) {
      if(!bandwidth.checked)
        return 0 + 'px';
      return Number(bandwidth.bandwidth) / Number(progressBar.max) * 100 + '%';
    },
    getImageUrl: function(asset, width, height) {
      if(!width) width = 1920;
      if(!height) height = 1080;

      if(asset.extension == "svg")
        return asset.url;
      else return `/img${asset.url}?w=${width}&h=${height}`;
    }
  },
  computed: {
    bandwidthSum: function() {
      if(this.bandwidthItems.length === 0)
        return 0;

      return this.bandwidthItems.filter((b) => {
        return b.checked;
      }).reduce((prev, next) => {
        return Number(prev) + Number(next.bandwidth);
      }, 0);
    }
  },
  mounted: function() {
    const bandwidthItems = JSON.parse(this.bandwidths);
    const randomNumbers = getRandomNumbers(0, bandwidthItems.length, 2);

    bandwidthItems.forEach((b, index) => {
      b.checked = randomNumbers.includes(index);
    });

		this.bandwidthItems = bandwidthItems;
		this.progressBarItems = JSON.parse(this.progressBars);
	}
};

function getRandomNumbers(min, max, limit) {
  var arr = [];
  while(arr.length < limit){
    var r = Math.floor(Math.random() * max) + min;
    if(arr.indexOf(r) === -1) 
      arr.push(r);
  }
  return arr;
}

</script>
